var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mr-navbar'),_c('graduate-presentation'),_c('our-services'),_c('weekly-schedule'),_c('lesson-schedule'),_c('forms'),_c('team'),_c('list-thesis-doctors'),_c('list-thesis-vue-route'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }